import React from 'react'
import { Stack, Typography } from '@mui/material'
import InformationalTooltip from '../../InformationalTooltip'
import sxs from './_sxs'
import { FormFieldLabelProps, FormFieldStatus } from './_props'
import { mergeSx } from '../../../../theme/_utils'
import { statusesProps } from './_status'

const FormFieldLabel: React.FC<FormFieldLabelProps> = ({
    label,
    disabled,
    status,
    tooltipTitle,
    labelSideComponent,
    required,
    tooltipPosition,
}) => {
    const inputStatus: FormFieldStatus = React.useMemo(() => {
        if (status?.error) return 'ERROR'
        if (status?.valid) return 'VALID'
        if (status?.warning) return 'WARNING'
        return 'IDLE'
    }, [status])

    const statusProps = statusesProps[inputStatus]
    const isErrorOrWarning = inputStatus === 'ERROR' || inputStatus === 'WARNING'

    return (
        <Stack
            flexDirection="row"
            alignItems="center"
            gap="0.5rem"
            sx={mergeSx([
                sxs.FormFieldLabel,
                disabled && !isErrorOrWarning ? sxs.UsertFormFieldLabelDisabled : undefined,
            ])}
        >
            <Typography sx={statusProps.classes?.label}>{`${label} ${
                required && label.trim().length > 0 ? '*' : ''
            }`}</Typography>
            {label && statusProps.icon}
            {tooltipTitle && tooltipPosition === 'overall' && <InformationalTooltip title={tooltipTitle} />}
            {labelSideComponent}
        </Stack>
    )
}

export default FormFieldLabel
